var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformationFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_10389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.13 3C10.3243 3 8.55907 3.53546 7.05765 4.53868C5.55623 5.5419 4.38601 6.96781 3.69498 8.6361C3.00396 10.3044 2.82315 12.1401 3.17543 13.9112C3.52772 15.6822 4.39727 17.309 5.67412 18.5859C6.95097 19.8627 8.57778 20.7323 10.3488 21.0846C12.1199 21.4368 13.9556 21.256 15.6239 20.565C17.2922 19.874 18.7181 18.7038 19.7213 17.2024C20.7245 15.7009 21.26 13.9357 21.26 12.13C21.2574 9.70939 20.2946 7.38867 18.583 5.67704C16.8713 3.96541 14.5506 3.00265 12.13 3ZM12.13 6.92C12.2586 6.92 12.3842 6.95813 12.4911 7.02955C12.598 7.10097 12.6813 7.20249 12.7305 7.32126C12.7797 7.44003 12.7926 7.57072 12.7675 7.69681C12.7424 7.8229 12.6805 7.93871 12.5896 8.02962C12.4987 8.12052 12.3829 8.18243 12.2568 8.20751C12.1307 8.23259 12 8.21972 11.8813 8.17052C11.7625 8.12133 11.661 8.03801 11.5895 7.93112C11.5181 7.82423 11.48 7.69856 11.48 7.57C11.48 7.39761 11.5485 7.23228 11.6704 7.11038C11.7923 6.98848 11.9576 6.92 12.13 6.92ZM14.3 17.02H9.89V15.52H11.39V11H9.95C9.75109 11 9.56033 10.921 9.41967 10.7803C9.27902 10.6397 9.2 10.4489 9.2 10.25C9.2 10.0511 9.27902 9.86033 9.41967 9.71967C9.56033 9.57902 9.75109 9.5 9.95 9.5H12.89V15.5H14.31L14.3 17.02Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_10389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.27,
    height: 18.26,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationFill);
export default __webpack_public_path__ + "static/media/InformationFill.b9788153.svg";
export { ForwardRef as ReactComponent };